import * as React from 'react';
const MyPlaylist = (props) => (
  <svg
    width={26}
    height={26}
    viewBox="0 0 26 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M7.75 8.48205L4.75 10.2141L4.75 6.75L7.75 8.48205Z" fill="white" />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M8.5 8.48205C8.5 8.75 8.35705 8.9976 8.125 9.13157L5.125 10.8636C4.89295 10.9976 4.60705 10.9976 4.375 10.8636C4.14295 10.7296 4 10.4821 4 10.2141L4 6.75C4 6.48205 4.14295 6.23446 4.375 6.10048C4.60705 5.96651 4.89295 5.96651 5.125 6.10048L8.125 7.83253C8.35705 7.96651 8.5 8.2141 8.5 8.48205ZM5.5 8.04904L5.5 8.91506L6.25 8.48205L5.5 8.04904Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.90039 13.6343L23.4004 13.6343L23.4004 14.9343L3.90039 14.9343L3.90039 13.6343Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10.9785 7.56787L23.4007 7.56787L23.4007 8.86787L10.9785 8.86787L10.9785 7.56787Z"
      fill="white"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M3.90039 19.7012L23.4004 19.7012L23.4004 21.0012L3.90039 21.0012L3.90039 19.7012Z"
      fill="white"
    />
  </svg>
);
export default MyPlaylist;
